import React from "react";

const LBadge = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="16"
      viewBox="0 0 22 16"
      fill="none"
    >
      <rect width="22" height="16" rx="8" fill="#BBCAFF" />
      <path
        d="M5.80859 11V4.5752H7.1709V9.875H9.77686V11H5.80859ZM12.7695 4.5752C13.3525 4.5752 13.833 4.64551 14.2109 4.78613C14.5918 4.92676 14.8745 5.13916 15.0591 5.42334C15.2437 5.70752 15.3359 6.06641 15.3359 6.5C15.3359 6.79297 15.2803 7.04932 15.1689 7.26904C15.0576 7.48877 14.9111 7.6748 14.7295 7.82715C14.5479 7.97949 14.3516 8.104 14.1406 8.20068L16.0303 11H14.5186L12.9849 8.53467H12.2598V11H10.8975V4.5752H12.7695ZM12.6729 5.69141H12.2598V7.42725H12.6992C13.1504 7.42725 13.4727 7.35254 13.666 7.20312C13.8623 7.05078 13.9604 6.82812 13.9604 6.53516C13.9604 6.23047 13.855 6.01367 13.644 5.88477C13.436 5.75586 13.1123 5.69141 12.6729 5.69141Z"
        fill="#140186"
      />
    </svg>
  );
};

export default LBadge;
